function BusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="currentColor"
        d="M15.2 3.717c.002-.117-.006-1.172-1.04-2.188C13.142.529 12.114.5 12 .5H3.997C3.806.5 2.802.55 1.83 1.542.83 2.562.8 3.587.8 3.7v2.4H0v2.4h.8v4.8a1.6 1.6 0 00.8 1.377V15.7a.8.8 0 00.8.8h.8a.8.8 0 00.8-.8v-.8h8v.8a.8.8 0 00.8.8h.8a.8.8 0 00.8-.8v-1.022c.477-.277.8-.787.8-1.378V8.5h.8V6.1h-.8V3.717zM5.6 2.1h4.8v1.6H5.6V2.1zm-2 11.2a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm3.6-4H2.4v-4h4.8v4zm5.2 4a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm1.2-4H8.8v-4h4.8v4z"
      ></path>
    </svg>
  );
}

export default BusIcon;
